// import { Select } from '@hyphengroup/modulab-react';
import { Select, Option } from '@material-tailwind/react';
import { useCallback } from 'react';
import { useTab } from './useTab';

export const TabViewerMobile = ({ tabs }: { tabs: string[] }) => {
  const { activeTab, onSetNewActiveTab, version } = useTab(tabs);

  const onChange = useCallback(
    (value?: string) => {
      onSetNewActiveTab((+(value ?? 1) - 1)!);
    },
    [onSetNewActiveTab],
  );

  const value = activeTab?.toString() ?? '';
  if (!version.mobile) {
    return null;
  }
  return (
    <Select
      className="rounded-radius/button border border-borders/default bg-fill/primary-light"
      value={value}
      menuProps={{
        className: 'p-0',
      }}
      onChange={onChange}
    >
      {tabs.map((tab, index) => {
        return (
          <Option
            className="rounded-none bg-black/70 text-text-secondary"
            key={tab}
            value={`${index + 1}`}
          >
            {tab}
          </Option>
        );
      })}
    </Select>
  );
};
